import { ProgressBar } from '@nwh-consumer-digital/nw-component-lib'

export default function ProgressBarComponent ({ value }) {
  return (
    <div>
      <ProgressBar value={value} />
    </div>
  )
}
